import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { fetchAccountPortalbackend } from './account-portal.helpers';
import { ACCOUNT_PORTAL_BACKEND_ROOT } from './auth';

export interface ContactSalesParams {
  email: string | null | undefined;
  trialUpgrade: string;
}

export type ContactSalesMutationOptions = Omit<
  UseMutationOptions<Response, Error, ContactSalesParams, unknown>,
  'mutationKey' | 'mutationFn'
>;

export function useContactSalesMutation(options?: ContactSalesMutationOptions) {
  return useMutation({
    ...options,
    mutationKey: ['auth', 'contact-sales'],
    mutationFn: async (params: ContactSalesParams) => {
      const email = params.email;
      if (
        email === null ||
        email === undefined ||
        String(email).trim() === ''
      ) {
        throw new Error('Contact sales requires an email address');
      }

      const url = `${ACCOUNT_PORTAL_BACKEND_ROOT}/api/users/hubspot/contactsales`;

      if (url.includes('/api/api')) {
        const errorMsg = `Contact sales URL contains doubled /api path: ${url}`;
        console.error(errorMsg);
        throw new Error(errorMsg);
      }

      const response = await fetchAccountPortalbackend(url, {
        method: 'POST',
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        throw new Error(
          `Contact sales request failed with status ${response.status}`
        );
      }

      return response;
    },
  });
}
